import React from "react"

import AccordionSection from "@slices/AccordionSection"
import CarouselSection from "@slices/CarouselSection"
import CodeBlock from "@slices/CodeBlock"
import ColumnSection from "@slices/ColumnSection"
import CuratedPostsSection from "@slices/CuratedPostsSection"
import HeroCard from "@slices/HeroCard"
import ImageGallery from "@slices/ImageGallery"
import Ingredient from "@slices/Ingredient"
import IngredientGroup from "@slices/IngredientGroup"
import InstagramSection from "@slices/InstagramSection"
import NewsletterSection from "@slices/NewsletterSection"
import RichTextSection from "@slices/RichTextSection"
import TrustPilotSection from "@slices/TrustpilotSection"
import CTASection from "@slices/CTASection"
import CategoryNavigation from "@slices/CategoryNavigation"
import HeroPostcodeCheck from "@slices/HeroPostcodeCheck"
import Boxes from "@slices/Boxes"
import CuratedRecipeSection from "@slices/CuratedRecipeSection"
import Community from "@slices/Community"
import CardSection from "@slices/CardSection"
import LeadGenSection from "@slices/LeadGenSection"
import BannerSection from "@slices/BannerSection"
import VideoCard from "@slices/VideoCard"
import HowItWorksSection from "@slices/HowItWorksSection"
import TickerTape from "@components/TickerTape"

const SliceZone = props => {
  const sliceComponents = {
    accordion_section: AccordionSection,
    body_text: RichTextSection,
    code_block_section: CodeBlock,
    column_section: ColumnSection,
    cta_section: CTASection,
    curated_posts_section: CuratedPostsSection,
    hero_section: HeroCard,
    image_gallery: ImageGallery,
    ingredient_group: IngredientGroup,
    ingredient: Ingredient,
    instagram_section: InstagramSection,
    newsletter_section: NewsletterSection,
    trustpilot_score_section: TrustPilotSection,
    category_navigation_: CategoryNavigation,
    carousel: CarouselSection,
    hero_section_postcode_check: HeroPostcodeCheck,
    boxes: Boxes,
    curated_recipe_section: CuratedRecipeSection,
    community: Community,
    card_section: CardSection,
    lead_gen_section: LeadGenSection,
    banner: BannerSection,
    video_card: VideoCard,
    how_it_works_section: HowItWorksSection,
    tickertape_item: TickerTape,
  }

  const sliceZoneContent = props.sliceZone.map((slice, index) => {
    const SliceComponent = sliceComponents[slice.slice_type]
    if (SliceComponent) {
      return (
        <React.Fragment key={`slice-${index}`}>
          <SliceComponent slice={slice} {...props} />
        </React.Fragment>
      )
    }
    return null
  })

  return <>{sliceZoneContent}</>
}

export default SliceZone
